import { useQuery } from '@tanstack/vue-query'
import gql from 'graphql-tag'

export function useRoundsWithMissingAssignments() {
  return useQuery({
    queryKey: ['rounds-with-missing-assignments'],
    queryFn: () => getRoundsWithMissingAssignments(),
  })
}

async function getRoundsWithMissingAssignments() {
  const { query } = useGqlMikro()

  const { data, errors } = await query({ query: ROUNDS_WITH_MISSING_ASSIGNMENTS_QUERY })

  if (errors && errors.length > 0) {
    throw errors
  }

  return data.roundsWithMissingAssignments
}

const ROUNDS_WITH_MISSING_ASSIGNMENTS_QUERY = gql`
query RoundsWithMissingAssignments {
  roundsWithMissingAssignments {
    count
    collection {
      totalWeight
      assignedDriver {
        id
        fullName
      }
      assignedTruck {
        id
        displayName
      }
      recycler {
        id
        name
      }
      id
      publicId
      name
      stops {
        status
        id
        address
        collectsInformations
        name
        address
        zipCode
        serviceTasks {
          notes
          description
          actualWeight
          id
          roundId
          serviceType
          treatmentCode
        }
        openingHours {
          monday {
            open
            close
          }
          tuesday {
            open
            close
          }
          friday {
            close
            open
          }
          saturday {
            close
            open
          }
          sunday {
            close
            open
          }
          thursday {
            close
            open
          }
          wednesday {
            close
            open
          }
        }
        collects {
          id
        }
        containers {
          collection {
            name
            id
            documents {
              collection {
                signedUrl
                id
                name
              }
            }
            material {
              name
              id
              standardMaterial {
                id
              }
              documents {
                collection {
                  signedUrl
                  id
                  name
                }
              }
            }
          }
        }
        client {
          name
          id
        }
      }
      roundType
      status
      collectIds
      scheduledDate
      outletAssignments {
        outletId
      }
    }
    count
  }
}`
